import React from 'react';
import { connect } from 'react-redux';
import { airportActions } from '../_actions';
import { NewAirportModal, DeleteAirportModal } from "../Airports"
import { Form, Row, Col } from 'reactstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

function deleteLinkFormatter(value, row, index, field) {
  return (
    <DeleteAirportModal className="full-width" color="danger" airport_id={row.value}></DeleteAirportModal>
  );
}

function selectDataFormatterLabel(cell, row) {
  return <span>{row.label}</span>
}

const columns = [{
  dataField: 'label',
  text: 'Aéroport',
  editable: true
},{
  dataField: 'delete',
  text: 'Supprimer',
  editable: false,
  formatter: deleteLinkFormatter
}];

const remote={
  filter: false,
  pagination: false,
  sort: false,
  cellEdit: true
}

class AllAirports extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
        airports: []
      };
    }

  componentDidMount() {
    this.props.getAllAirports();
  }

  onTableChange(type, newState) {
    if(type==="cellEdit")
    {
      this.props.handleChange(newState.cellEdit);
    }
    return true;
  }

  render() {
    return (
      <div style={{marginLeft:"5%", marginRight:"5%"}}>
        <Row>
          <Col md="3" xs="6" style={{marginBottom: "10px"}}><NewAirportModal buttonLabel="Nouvel aéroport" /></Col><Col md="1" xs="6"></Col>
        </Row>
        <br/>
        { this.props.airports && this.props.airports.items && this.props.airports.items.length > 0 &&
          <div className="table-responsive-sm">
            <BootstrapTable style={{ margin:"auto"}} bootstrap4={true} bordered={false} keyField='value' remote={remote} cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true }) } onTableChange={this.onTableChange.bind(this)} data={ this.props.airports.items } columns={ columns } />
          </div>
        }
      </div>
    )

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (edit) => {
      dispatch(airportActions.update({...edit, rowId:edit.rowId.value}));
    },
    getAllAirports: () => {
      dispatch(airportActions.getAll());
    }
  }
}

function mapStateToProps(state){
    return {
        airports: state.airports
    }
}

const connectedAllAirports = connect(mapStateToProps, mapDispatchToProps)(AllAirports);
export { connectedAllAirports as AllAirports };
